import {IDatasetConfig, DatasetActionOpenType, ListViewItemTypes } from 'app/interfaces';
import {fieldsMap} from './fields';
import textForm from './forms/text.form';

const beforeCallDetail = {
	name: 'record',
	path: '/dataset/trip_facility_language_contents/detail/:recordId',
};

export const TripFacilityLanguageContentConfig: IDatasetConfig = {
	name: 'trip_facility_language_contents',
	title: 'Informazioni Utili',
	singleTitle: 'Informazioni Utili',
	ajaxDatasetCode: 'trip_facility_language_contents',
	fieldsMap: fieldsMap,
	supportProperties: true,
	enabledActions: {
		detail: false,
		create: false,
		edit: true,
		list: true
	},
	formConfigsMap: {
		textForm
	},
	defaultActions: {
		edit: {
			openType: DatasetActionOpenType.PAGE,
			viewConfig: {
				formConfig: textForm
			}
		},
		list: {
			openType: DatasetActionOpenType.PAGE,
			viewConfig: {
				itemViewType: ListViewItemTypes.TABLE,
				showSearchBar: true,
				defaultSortBy: 'created_at',
				defaultSortDirection: 'desc',
				columns: [
					{
						title: 'Lingua',
						key: 'lang'
					},
					{
						title: 'Descrizione',
						key: 'description'
					}
				],
				actions: ['create', 'detail', 'delete']
			}
		}
	}
};
